import IntegerMixin from 'trunks/vue/share/components/fields/integer.js';
import FieldMixinForResponse from './mixin.js';
import LogicalRadioButtonMixin from 'trunks/vue/share/mixins/logic_field/integer.js';

const IntegerForResponse = {
  mixins: [
    FieldMixinForResponse,
    IntegerMixin,
    LogicalRadioButtonMixin
  ],

  template: `
    <Field :field='field'
           v-show='visible'
           :extendClass='[fieldCommonClass, fieldDifferenceClass]'
           :message='errorMsg'>
      <template slot='input'>
        <input class='form-field-value'
               type="number"
               :readonly="!editing"
               v-model='value'
               v-integer
               placeholder='请输入'
               @input.stop.prevent='userInput'
               ref='input'/>
      </template>
    </Field>
  `
};

export default IntegerForResponse;
